import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const fulfillmentBatchCardDefaultVariants = {}
const fulfillmentBatchCardCompoundVariants = []

const fulfillmentBatchCardSlotNames = [
  [
    "root",
    "fulfillment-batch-card__root"
  ],
  [
    "stat",
    "fulfillment-batch-card__stat"
  ]
]
const fulfillmentBatchCardSlotFns = /* @__PURE__ */ fulfillmentBatchCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, fulfillmentBatchCardDefaultVariants, getSlotCompoundVariant(fulfillmentBatchCardCompoundVariants, slotName))])

const fulfillmentBatchCardFn = memo((props = {}) => {
  return Object.fromEntries(fulfillmentBatchCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const fulfillmentBatchCardVariantKeys = []
const getVariantProps = (variants) => ({ ...fulfillmentBatchCardDefaultVariants, ...compact(variants) })

export const fulfillmentBatchCard = /* @__PURE__ */ Object.assign(fulfillmentBatchCardFn, {
  __recipe__: false,
  __name__: 'fulfillmentBatchCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: fulfillmentBatchCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, fulfillmentBatchCardVariantKeys)
  },
  getVariantProps
})